import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiEndpoints } from '../constants/api-endpoints';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class HouseService {
  constructor(private readonly api: ApiService) {}

  create(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.HOUSE_CREATE, payload);
  }

  update(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.HOUSE_UPDATE, payload);
  }

  delete(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.HOUSE_DELETE, payload);
  }

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.HOUSE_LIST, payload);
  }
}
